// 对 天地图 图层 进行添加
// 20190108 todo 完成 添加 或 测试

const defaultKey = 'aeb66810e08d1c2effa2a76a06f5279f'

// http://t0.tianditu.gov.cn/vec_c/wmts?tk=您的密钥

const typeList = [
  'vec_c',
  'cva_c',
  'img_c',
  'cia_c',
  'ter_c',
  'cta_c',
  'ibo_c',
  'eva_c',
  'eia_c'
]

const defaultLayer = 'img'
const defaultProjection = 'c'

function getTDTLayer (layerInfo) {
  // self = self || this
  //
  const params = layerInfo.params
  // 设置 key
  const tdtKey = params.key || defaultKey
  const tdtlayer = params.layer || defaultLayer
  const tdtProjection = params.projection || defaultProjection
  // 图层最大值
  const maximumLevel = params.maximumLevel || 13
  // 设置 key
  var tdtProvider = new Cesium.WebMapTileServiceImageryProvider({
    url:
      `http://t0.tianditu.gov.cn/${tdtlayer}_${tdtProjection}/wmts?tk=${tdtKey}`,
    layer: tdtlayer,
    style: 'default',
    tileMatrixSetID: tdtProjection,
    format: 'tiles',
    maximumLevel: maximumLevel
  })

  // viewer.imageryLayers.addImageryProvider( tdtProvider );
  return tdtProvider
}

/**
 * 添加天地图 基于 TMS的贴图服务
 * @param {Object} layerInfo http://lbs.tianditu.gov.cn/docs/#/sanwei/
 * @returns 天地图 Provider
 * @example
 *   function addTDTLayer() {
 *      const defaultTDT = {
 *        id: 'testWMSsdasrewqdas',
 *        mapType: 'tdt',
 *        params: {
 *          key: '82cf878ce0a7719801f26ca2dcee8b73',
 *          layer: 'img',
 *          projection: 'w'
 *        }
 *      }
 *     m3DMapClass.addLayer(defaultTDT)
 *  }
 */
function getTDTLayerTMS (layerInfo) {
  // self = self || this
  //
  const params = layerInfo.params
  // 设置 key
  const tdtKey = params.key || defaultKey
  const tdtlayer = params.layer || defaultLayer
  const tdtProjection = params.projection || defaultProjection
  // 图层最大值
  const maximumLevel = params.maximumLevel || 18

  // 服务域名
  const tdtUrl = 'https://t{s}.tianditu.gov.cn/'
  // 服务负载子域
  const subdomains = ['0', '1', '2', '3', '4', '5', '6', '7']
  // 设置 key
  var imgMap = new Cesium.UrlTemplateImageryProvider({
    url: tdtUrl + `DataServer?T=${tdtlayer}_w&x={x}&y={y}&l={z}&tk=` + tdtKey,
    subdomains: subdomains,
    tilingScheme: new Cesium.WebMercatorTilingScheme(),
    maximumLevel: maximumLevel
  })
  // var tdtProvider = new Cesium.WebMapTileServiceImageryProvider({
  //   url:
  //     `http://t0.tianditu.gov.cn/${tdtlayer}_${tdtProjection}/wmts?tk=${tdtKey}`,
  //   layer: tdtlayer,
  //   style: 'default',
  //   tileMatrixSetID: tdtProjection,
  //   format: 'tiles',
  //   maximumLevel: maximumLevel
  // })

  // viewer.imageryLayers.addImageryProvider( tdtProvider );
  return imgMap
}

export { getTDTLayer, getTDTLayerTMS }
